import { ToastrService } from 'ngx-toastr';

import { Component, ChangeDetectionStrategy, EventEmitter, Output, Input, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';

import { FormBaseComponent } from '@bp/shared/components/core';
import { Validators } from '@bp/shared/features/validation';
import { ensureFormGroupConfig } from '@bp/shared/typings';

import type { SecurityQuestion, ISecurityQuestionAnswerApiRequest } from '@bp/admins-shared/domains/identity';

@Component({
	selector: 'bp-provide-security-question-answer-form',
	templateUrl: './provide-security-question-answer-form.component.html',
	styleUrls: [ './provide-security-question-answer-form.component.scss' ],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProvideSecurityQuestionAnswerFormComponent extends FormBaseComponent<ISecurityQuestionAnswerApiRequest> {

	@Input() identitySecurityQuestions!: SecurityQuestion[] | null;

	@Input() hasAnotherWay?: boolean | null;

	@Output() readonly tryAnotherWay = new EventEmitter<void>();

	override onSubmitShowInvalidInputsToast = false;

	constructor(
		fb: UntypedFormBuilder,
		cdr: ChangeDetectorRef,
		toaster: ToastrService,
	) {
		super(fb, cdr, toaster);

		this.form = this._formBuilder.group(ensureFormGroupConfig<ISecurityQuestionAnswerApiRequest>({
			id: [ null, [ Validators.required ]],
			answer: [ null, [ Validators.required ]],
		}));
	}
}
